/**
 * @typedef {Object} ReasonGroup
 * @property {string} id
 * @property {string} label
 * @property {Array<{id: string, label: string}>} subReasons
 */

/**
 * @typedef {Object} VideoResponse
 * @property {string} id
 * @property {string} residentName
 * @property {?string} unitNumber
 * @property {string} submittedAt
 * @property {Array<ReasonGroup>} reasonGroups
 * @property {{url: string, thumbnailUrl: ?string, durationSeconds: ?number}} video
 */

/**
 * @param {{residentName: string, unitNumber: ?string}} response
 * @return {string}
 */
export function formatResidentLine(response) {
  return response.unitNumber ? `${response.residentName}, ${response.unitNumber}` : response.residentName
}
